import * as React from "react";
const ContactIconSVG = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.714}
        d="M4.286 10V6.243A5.614 5.614 0 0 1 10.001.714a5.614 5.614 0 0 1 5.714 5.529V10m-2.857 7.5a2.857 2.857 0 0 0 2.857-2.857v-3.214M12.858 17.5a1.786 1.786 0 0 1-1.786 1.786H8.929a1.786 1.786 0 1 1 0-3.572h2.143a1.786 1.786 0 0 1 1.786 1.786ZM2.143 7.857h1.429a.714.714 0 0 1 .714.714v4.286a.714.714 0 0 1-.714.714H2.143a1.429 1.429 0 0 1-1.428-1.428V9.286a1.429 1.429 0 0 1 1.428-1.429Zm15.715 5.714h-1.429a.714.714 0 0 1-.714-.714V8.571a.714.714 0 0 1 .714-.714h1.429a1.429 1.429 0 0 1 1.428 1.429v2.857a1.429 1.429 0 0 1-1.428 1.428Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h20v20H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default ContactIconSVG;
